import { render, staticRenderFns } from "./Chinese.vue?vue&type=template&id=1c5c1027&scoped=true"
import script from "./Chinese.vue?vue&type=script&lang=js"
export * from "./Chinese.vue?vue&type=script&lang=js"
import style0 from "./Chinese.vue?vue&type=style&index=0&id=1c5c1027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c1027",
  null
  
)

export default component.exports